<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>ROI</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="推广渠道" prop="startDate">
            <el-select v-model.number="queryParams.platForm" filterable placeholder="请选择">
              <el-option
                v-for="item in channel"
                :key="item.value"
                filterable
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="国家" prop="startDate">
            <el-select v-model="queryParams.country" filterable placeholder="请选择">
              <el-option

                v-for="item in country"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
            <el-upload
              ref="upload"
              style="display: inline-block;margin-left: 10px"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="xlsx"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res)}"
              :headers="headers"
            >
              <el-button v-permisaction="['config:roi:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
            </el-upload>
            <el-button style="margin-left: 10px;" icon="el-icon-download" type="primary" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />

      </el-card>
      <el-card>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="100px"
            align="center"
          />
          <el-table-column
            prop="ad_price"
            label="投放花费"
            align="center"
          />
          <el-table-column
            prop="ad_install"
            label="广告安装"
            align="center"
          />
          <el-table-column
            prop="ad_count"
            label="广告新增"
            align="center"
          />
          <el-table-column
            prop="cpi"
            label="CPI"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="320"
                trigger="hover"
                content="CPI=投放花费/安装"
              >
                <span slot="reference">CPI <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">{{ scope.row.cpi }}</template>
          </el-table-column>
          <el-table-column
            prop="cac"
            label="CAC"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="320"
                trigger="hover"
                content="单个用户的获取成本"
              >
                <span slot="reference">CAC <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">{{ scope.row.cac }}</template>
          </el-table-column>

          <el-table-column
            label="预估"
            align="center"
          >
            <el-table-column
              prop="estimated_price"
              label="30天内充值"
              align="center"
              width="120"
            >
              <template scope="scope">
                {{ scope.row.estimated_price }}
                <!--                <span v-if="!scope.row.edit" @click="handleAdPrice(scope.$index)">-->
                <!--                  <i-->
                <!--                    style="color:#409EFF"-->
                <!--                    class="el-icon-edit"-->
                <!--                  /> {{ scope.row.estimated_price }}-->
                <!--                </span>-->
                <!--                <span v-else>-->
                <!--                  <el-input-->
                <!--                    v-model="scope.row.estimated_price"-->
                <!--                    size="small"-->
                <!--                    @blur="saveAdPrice(scope.$index, scope.row.estimated_price)"-->
                <!--                  />-->
                <!--                </span>-->
              </template>
            </el-table-column>
            <el-table-column
              prop="estimated_remain"
              label="30天内留存"
              align="center"
              width="120"
            >
              <template scope="scope">
                {{ scope.row.estimated_remain }}
                <!--                <span v-if="!scope.row.edit" @click="handleAdPrice(scope.$index)">-->
                <!--                  <i-->
                <!--                    style="color:#409EFF"-->
                <!--                    class="el-icon-edit"-->
                <!--                  /> {{ scope.row.estimated_remain }}-->
                <!--                </span>-->
                <!--                <span v-else>-->
                <!--                  <el-input-->
                <!--                    v-model="scope.row.estimated_remain"-->
                <!--                    size="small"-->
                <!--                    @blur="saveAdPrice(scope.$index, scope.row.estimated_remain)"-->
                <!--                  />-->
                <!--                </span>-->
              </template>
            </el-table-column>
            <el-table-column
              prop="ltv"
              label="LTV"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="LTV=累计付费/注册人数"
                >
                  <span slot="reference">LTV <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.estimated_ltv }}</template>
            </el-table-column>
            <el-table-column
              prop="arpu"
              label="ARPU"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="ARPU=总充值/总活跃"
                >
                  <span slot="reference">ARPU <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.estimated_arpu }}</template>
            </el-table-column>
            <el-table-column
              prop="roi"
              label="roi"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="ROI = LTV / CAC"
                >
                  <span slot="reference">ROI <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.estimated_roi }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="实际"
            align="center"
          >
            <el-table-column
              prop="pay_price"
              label="30天内充值"
              align="center"
            />
            <el-table-column
              prop="remain"
              label="30天内留存"
              align="center"
            />
            <el-table-column
              prop="ad_count"
              label="广告新增"
              align="center"
            />
            <el-table-column
              prop="ltv"
              label="LTV"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="LTV=累计付费/注册人数"
                >
                  <span slot="reference">LTV <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.ltv }}</template>
            </el-table-column>
            <el-table-column
              prop="arpu"
              label="ARPU"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="ARPU=总充值/总活跃"
                >
                  <span slot="reference">ARPU <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.arpu }}</template>
            </el-table-column>
            <el-table-column
              prop="cpi"
              label="CPI"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="CPI=投放花费/安装"
                >
                  <span slot="reference">CPI <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.cpi }}</template>
            </el-table-column>
            <el-table-column
              prop="cac"
              label="CAC"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="单个用户的获取成本"
                >
                  <span slot="reference">CAC <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.cac }}</template>
            </el-table-column>
            <el-table-column
              prop="roi"
              label="roi"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="320"
                  trigger="hover"
                  content="ROI = LTV / CAC"
                >
                  <span slot="reference">ROI <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.roi }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>
      <AdBillData />

    </template>
  </BasicLayout>
</template>

<script>
import { getAd, importAd } from '@/api/statistics/user_remain'
import AdBillData from '@/views/config/roi/components/ad-stat.vue'
import echarts from 'echarts'
import { getToken } from '@/utils/auth'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'ROI',
  components: {
    AdBillData
  },
  data() {
    return {
      channel: [
        { label: '全部', value: 0 },
        { label: 'FB推广渠道', value: 1 },
        { label: '谷歌推广渠道', value: 2 },
        { label: 'Apple Ads', value: 3 },
        { label: 'UnityAds', value: 4 },
        { label: 'TAURUSX-Playwell', value: 5 }
      ],
      country: [],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: 0,
        type: 0
      },
      loading: false,
      options: [],
      tableData: [],
      tableData2: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables(undefined)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.type = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getAd(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          for (const i in res.data.data) {
            res.data.data[i].edit = false
          }
          this.tableData = res.data.data
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          this.country = [{ value: '0', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: country[i], label: country[i] })
          }
          const data = []
          this.date = []

          res.data.data.forEach((res, index) => {
            this.date.push(res.date)
            data.push(res.roi)
          })

          this.option.xAxis.data = this.date
          this.option.series[0].data = data
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          // text: 'ROI'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          // data: ['次日', '3日', '7日', '15日', '30日'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            // name: '次日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importAd({ data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.queryParams.type = 1
      getAd(this.queryParams).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleAdPrice(idx) {
      this.tableData[idx].edit = true
    },
    saveAdPrice(idx, adPrice) {}
  }
}
</script>

<style scoped>
</style>
